/**
 * W4 (field test 2026-10-16) — the browser's ONLY write path for an approved rollover: ask the server to re-plan it.
 *
 * The browser never writes chain rows for a conversion. It may ask `rollover-decision` { action: 'maintain' } — an
 * idempotent request the server answers with a NO-OP when nothing material changed, or one compare-and-set
 * checkpoint. Throttled per conversion (5 minutes) so open tabs never produce per-minute writes.
 */
import { supabase } from '@/integrations/supabase/client';

export const MAINTAIN_THROTTLE_MS = 5 * 60_000;
const lastAsked = new Map<string, number>();

export function shouldRequestMaintenance(conversionId: string, nowMs: number, last = lastAsked): boolean {
  const prev = last.get(conversionId);
  if (prev !== undefined && nowMs - prev < MAINTAIN_THROTTLE_MS) return false;
  last.set(conversionId, nowMs);
  return true;
}

export async function requestConversionMaintenance(conversionId: string, nowMs = Date.now()): Promise<'requested' | 'throttled' | 'failed'> {
  if (!shouldRequestMaintenance(conversionId, nowMs)) return 'throttled';
  const { error } = await supabase.functions.invoke('rollover-decision', { body: { action: 'maintain', conversionId } });
  return error ? 'failed' : 'requested';
}
